export enum LoginTypes {
  Ethic = 'ethic',
  Zendesk = 'zendesk',
}

export function isLoginType(type: string): type is LoginTypes {
  return Object.values(LoginTypes).includes(type as LoginTypes);
}
